module.exports = __webpack_public_path__ + "img/thunderstorms.e8580b40.png";